import { Accordion, AccordionDetails, AccordionSummary, Grid2 } from "@mui/material";
import CustomInput from "./CustomInput";
import { ExpandMore } from "@mui/icons-material";
import Text from "./Text";

const GenericViewInputs = ({ viewObject, baseKey }) => {
    const getViewInputs = (obj, objkey) => {
        return Object.entries(obj).map(([key, value]) => {
            if (key == "__typename") return null;
            if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
                return (
                    <Accordion key={key}>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Text text={"i18n_" + objkey + "_" + key} component="span" />
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid2 container spacing={1}>
                                {getViewInputs(value, !objkey ? key : objkey + "_" + key)}
                            </Grid2>
                        </AccordionDetails>
                    </Accordion>

                )
            } else {
                const numeric = !isNaN(value) && !isNaN(parseFloat(value)); // ...and ensure strings of whitespace fail  
                let inputvalue = value;
                if (numeric) {
                    inputvalue = parseFloat(value).toFixed(2);
                }
                return <CustomInput
                    key={key}
                    type={"String"}
                    onChange={() => { }}
                    value={inputvalue}
                    placeholder={<Text text={`i18n_${objkey}_${key}`} />}
                />
            }

        })
    }
    const inputs = getViewInputs(viewObject, baseKey);
    return <Grid2 container spacing={1}>
        {inputs}

    </Grid2>
}
export default GenericViewInputs;